module.exports = "/_next/static/images/mokubaza_menu_top-ca5cb5c5fb83479629bd7ecaddf557d5.jpg";